import { getPostResetRedirect, ResetPasswordApp } from './resetPasswordApp';

export const POST_RESET_REDIRECT_DELAY_MS = 3000;

interface InviteCredentials {
  token: string;
  uid: string;
  email: string;
}

export interface CompletePasswordSetupInput {
  app: ResetPasswordApp;
  password: string;
  oobCode: string | null;
  // Zaproszenie (nasz token z inviteTokens), tylko gdy token został pozytywnie zweryfikowany.
  invite: InviteCredentials | null;
}

export interface CompletePasswordSetupDeps {
  confirmPasswordReset: (code: string, password: string) => Promise<void>;
  setUserPassword: (args: { uid: string; newPassword: string; token: string }) => Promise<unknown>;
  activateAccount: (args: { email: string }) => Promise<unknown>;
  signIn: (email: string, password: string) => Promise<unknown>;
  navigate: (path: string) => void;
  schedule: (fn: () => void, ms: number) => void;
}

export type CompletePasswordSetupResult = 'success' | 'missingCredentials';

/**
 * Zapis nowego hasła (zaproszenie albo reset z oobCode) i dalszy krok zależny od wariantu.
 * Wyciągnięte z komponentu, żeby przetestować bez DOM, że Staff nie loguje do panelu i nie przekierowuje.
 * Błędy Firebase/backendu przechodzą do wywołującego.
 */
export const completePasswordSetup = async (
  { app, password, oobCode, invite }: CompletePasswordSetupInput,
  deps: CompletePasswordSetupDeps,
): Promise<CompletePasswordSetupResult> => {
  if (invite) {
    await deps.setUserPassword({ uid: invite.uid, newPassword: password, token: invite.token });
    await deps.activateAccount({ email: invite.email });

    const redirect = getPostResetRedirect(app, 'invite');
    if (redirect) {
      // Logowanie do panelu tylko wtedy, gdy zaraz do niego przechodzimy.
      await deps.signIn(invite.email, password);
      deps.schedule(() => deps.navigate(redirect), POST_RESET_REDIRECT_DELAY_MS);
    }
    return 'success';
  }

  if (oobCode) {
    await deps.confirmPasswordReset(oobCode, password);
    const redirect = getPostResetRedirect(app, 'reset');
    if (redirect) deps.schedule(() => deps.navigate(redirect), POST_RESET_REDIRECT_DELAY_MS);
    return 'success';
  }

  return 'missingCredentials';
};
